import ENUM from '../ENUM'

export default function () {
    return {
        kind: 'LoyaltyMatrixSlide',
        filters: [
            {
                name: ENUM().comparisonSurveyIds,
            },
            {
                name: ENUM().benchmarks,
            },
        ],
    }
}
